<template lang="pug">
.footer
  .container
    dl
      dt 产品服务
      dd
        router-link(to="/price") 套餐选购
    dl
      dt 关于我们
      dd
        router-link(to="/contact") 产品介绍
      dd
        router-link(to="/contact") 商务合作
      dd
        router-link(to="/contact") 产品优势
    dl
      dt 联系我们
      dd 邮箱：sales@oncdp.com
      dd 地址：杭州市西湖区文一西路522号
        br
        | 9幢1单元602室
  .icp © 2026 {{ icpCompany }} |&nbsp;
    a(:href="icpHref", target="_blank")
      span(id="isp") {{icpText}} |&nbsp;
    //- a(href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602008546", target="_blank")
    //-   img(src="../assets/beian.png", style="margin-top: -5px;margin-right:3px;vertical-align:middle;")
    //-   | 浙公网安备 33010602008546 号
</template>

<script>
export default {
  name: 'layout-footer',
  data () {
    return {
      icpHref: 'https://beian.miit.gov.cn/',
      icpText: '浙ICP备2026057017号-1',
      icpCompany: '杭州优湃智能科技有限公司',
      domainList: {
        'www.zhidian-inc.cn': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-1'
        },
        'www.upcdn.net': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-2'
        },
        'www.aicdn.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-7'
        },
        'www.upaiyun.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-9'
        },
        'www.oncdp.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-4'
        },
        'www.aicdn5.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-18'
        },
        'www.cdnv1.net': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-20 '
        },
        'www.aicdn4.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-17'
        },
        'www.aicdn2.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-11'
        },
        'www.cdnv2.net': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-19'
        },
        'www.aicdn3.com': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备15031660号-13'
        },
        'www.upai.com': {
          icpCompany: '杭州优湃智能科技有限公司',
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备2026057017号-1'
        },
        'localhost': {
          icpHref: 'https://beian.miit.gov.cn/',
          icpText: '浙ICP备2026057017号-1'
        }
      }
    }
  },
  mounted () {
    const domain = window.location.hostname
    if (domain) {
      this.icpHref = this.domainList[domain].icpHref
      this.icpText = this.domainList[domain].icpText
      if (this.domainList[domain].icpCompany) {
        this.icpCompany = this.domainList[domain].icpCompany
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.footer
  padding: 50px 0 0
  background-color: #333333
  color: #ffffff

.container
  display: flex
  width: 660px
  margin: 0 auto 20px
  justify-content: space-between

dt
  margin-bottom: 20px
  font-weight: 500

dd
  margin-top: 10px
  color: rgba(255,255,255,0.6)
  a
    color: rgba(255,255,255,0.6)
    text-decoration: none

.icp
  text-align: center
  font-size: 13px
  line-height: 4em
  a
    color: inherit
    text-decoration: inherit
</style>



// WEBPACK FOOTER //
// footer.vue?3c251cb5